import { TimestampLike } from '@monitor/shared';

/** Compact relative time, e.g. "3m ago", "2h ago", "just now". */
export function timeAgo(ts: TimestampLike | null | undefined, nowMs: number): string {
  if (!ts) return 'never';
  const diff = nowMs - ts.toMillis();
  if (diff < 45_000) return 'just now';
  const mins = Math.round(diff / 60_000);
  if (mins < 60) return `${mins}m ago`;
  const hrs = Math.round(mins / 60);
  if (hrs < 24) return `${hrs}h ago`;
  return `${Math.round(hrs / 24)}d ago`;
}

export function formatTime(ts: TimestampLike | null | undefined): string {
  if (!ts) return '—';
  return ts.toDate().toLocaleString();
}
